var map = {
	"./DrLubhani/ChangeColor": [
		786,
		186
	],
	"./Ganga/ChangeColor": [
		788,
		192
	],
	"./Indus/ChangeColor": [
		790,
		205
	],
	"./Kabini/ChangeColor": [
		792,
		212
	],
	"./Kaveri/ChangeColor": [
		696,
		20
	],
	"./Luni/ChangeColor": [
		794,
		218
	],
	"./Narmada/ChangeColor": [
		796,
		221
	],
	"./Neyyar/ChangeColor": [
		798,
		228
	],
	"./Periyar/ChangeColor": [
		800,
		231
	],
	"./SAANVI/ChangeColor": [
		802,
		241
	],
	"./Sabarmathi/ChangeColor": [
		804,
		248
	],
	"./Sparsh - Copy/ChangeColor": [
		808,
		254
	],
	"./Sparsh/ChangeColor": [
		806,
		258
	],
	"./Sutlej/ChangeColor": [
		810,
		262
	],
	"./Yamuna/ChangeColor": [
		812,
		268
	],
	"./pamba/ChangeColor": [
		814,
		277
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2083;
module.exports = webpackAsyncContext;